export default {
	state: {
		//地图组件
		map: null,
	},
	mutations: {
		SET_map (state, key) {
			state.map = key
		},
	}
}
